import { Spin } from 'antd';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';
import { formatPrice } from '../../../until';

const COLORS = {
    KIA: '#8979FF',
    MAZDA: '#FF928A',
    BMW: '#3CC3DF',
    PEUGEOT: '#FFBE70',
    MINI: '#7599F4',
    'TẢI': '#8CDAAA',
    'BUS & MINIBUS': '#A382E1',
    'PEUGEOT MTC': '#55C5E3',
    MOTORRAD: '#4CA9FF',
    'KHÁC': '#CCCCCC'
};


interface props {
    data: any[]
    brandsCarOwnedBrandByUnit: any[]
    showLoading: boolean
}

const VehicleOwnershipChart: React.FC<props> = ({
    data,
    brandsCarOwnedBrandByUnit,
    showLoading
}) => {
    return (
        <div style={{ width: '100%', height: 520 }}>
            {
                showLoading ?
                    <ResponsiveContainer>
                        <BarChart
                            data={data}
                            margin={{ top: 2, right: 2, left: 20, bottom: 2 }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis
                                dataKey="dealer"
                                angle={-30}
                                textAnchor="end"
                                interval={0}
                                height={120}
                                
                            />
                            <YAxis tickFormatter={(value: number) => formatPrice(value)} />
                            {data.length && <Tooltip formatter={(value: number | string) => formatPrice(value)} />}

                            <Legend verticalAlign="bottom" height={40} />
                            {brandsCarOwnedBrandByUnit.length > 0 ? brandsCarOwnedBrandByUnit.map(brand => (
                                <Bar dataKey={brand.title} stackId="a" fill={brand.color} barSize={89} />
                            )) : null}
                        </BarChart>
                    </ResponsiveContainer>
                    :
                    <div
                        className='custom-page-css flex flex-col gap-2 items-center justify-center'
                        style={{ width: '100%', height: '100%' }}
                    >
                        <Spin size="default" />
                        <span>Đang tải...</span>
                    </div>
            }
        </div>
    );
}

export default VehicleOwnershipChart